import axios from "./axiosConfig";
import { apis } from './params';

export function getPartPaymentService(_param: any) {
    return axios({
        "method": "Get",
        "url": apis.GET_PART_PAYMENT_PRODUCTS + _param
    })
}

export function downloadPartPaymentService(_param: any) {
    return axios({
        "method": "Get",
        "url": apis.DOWNLOAD_PART_PAYMENT + _param,
        "responseType": "blob"
    })
}

export function uploadPartPaymentFileService(_data: any) {
    return axios({
        "method": "Post",
        "url": apis.UPLOAD_PART_PAYMENT_FILE + _data.param,
        "data": _data.data,
        "headers": {
            "Content-Type": "multipart/form-data"
        }
    })
}
